// removed by extract-text-webpack-plugin
module.exports = {"word-switcher":"word-switcher","placeholder":"placeholder","word":"word","enter":"enter","visible":"visible","leave":"leave"};


//////////////////
// WEBPACK FOOTER
// ./src/presentation/component/word-switcher/word-switcher.style.sass
// module id = TzRF
// module chunks = 1